import moment from 'moment'

export const UTCtoEspecificMaskDate = (utcDate, mask) => {
  return moment.utc(utcDate).format(mask)
}

export const getLast30DaysFromToday = () => {
  return moment().subtract(30, 'days').format('YYYY-MM-DD')
}

export const getTodayDate = (mask) => {
  return moment().format(mask)
}

export const getLast30DaysFromTodayObj = () => {
  return moment().subtract(30, 'days').toDate()
}

export const getLast15DaysFromTodayObj = () => {
  return moment().subtract(15, 'days').toDate()
}

export const getLast7DaysFromTodayObj = () => {
  return moment().subtract(7, 'days').toDate()
}

export const getTodayDateObj = () => {
  return moment().toDate()
}
